import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import SwipeUp from "components/Swipe/SwipeUp";

export interface Props
  extends React.HTMLAttributes<HTMLElement>,
    RouteComponentProps {
  onSwipeHome?: () => void;
  swipeMessageKey?: string;
  swipeConfirmKey?: string;
  enableSwipe?: boolean;
}

const SwipeHome = ({
  children,
  history,
  onSwipeHome,
  swipeConfirmKey,
  swipeMessageKey,
  enableSwipe = true,
  ...props
}: Props) => {
  const onSwipeEnd = () => {
    onSwipeHome != null && onSwipeHome();
    history.replace("/");
  };

  return (
    <SwipeUp
      onSwipeEnd={onSwipeEnd}
      swipeConfirmKey={swipeConfirmKey}
      swipeMessageKey={swipeMessageKey}
      iconType={"delete"}
      swipeHeight={11}
      enableSwipe={enableSwipe}
      {...props}
    >
      {children}
    </SwipeUp>
  );
};

export default withRouter(SwipeHome);
